import React from 'react';
import { 
  FaDoorOpen, 
  FaCrown, 
  FaUser 
} from 'react-icons/fa';
import { IoLanguage } from 'react-icons/io5';
import { useAuth } from '../../contexts/AuthContext';

const Header = () => {
  const { user, logout } = useAuth();

  const isSuperAdmin = () => user?.role_id === 1;
  const isAdmin = () => user?.role_id === 2;

  const handleLogout = () => {
    logout();
  };

  return (
    <header className="dashboard-header">
      <div className="header-left">
        <h1 className="page-title"><IoLanguage /> Chinese Proverbs Dashboard</h1>
        <p className="page-subtitle">Manage multilingual proverb collection with Firebase integration</p>
      </div>
      <div className="user-section">
        <div className="user-info">
          <div className="user-avatar">
            {user?.email === 'khouloud.bhlel@gmail.com' ? <FaCrown /> : <FaUser />}
          </div>
          <div className="user-details">
            <div className="user-name">Welcome, {user?.firstName || user?.name || 'User'}!</div>
            <div className="user-role">
              {isSuperAdmin() ? 'Super Administrator' : isAdmin() ? 'Administrator' : 'User'}
            </div>
          </div>
        </div>
        <button onClick={handleLogout} className="logout-btn">
          <FaDoorOpen /> Logout
        </button>
      </div>
    </header>
  );
};

export default Header;
